import PropTypes from 'prop-types';
export const DEFAULT_ERROR_TITLE = 'Error';
export const NOTIFICATION_ROLES = {
    INFO: 'info',
    CAUTION: 'caution',
    ERROR: 'error',
    SUCCESS: 'success',
};
export const DEFAULT_NOTIFICATION_OPTIONS = Object.freeze({
    title: '',
    message: '',
    role: NOTIFICATION_ROLES.INFO,
    showIcon: true,
    iconName: '',
    duration: 5000,
    autoDismiss: true,
    dismissible: true,
});
export const DISMISSIBLE_DURATION_THRESHOLD = 5000;
export const NotificationPropTypes = PropTypes.shape({
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
});
export const NotifierPropTypes = PropTypes.shape({
    info: PropTypes.func.isRequired,
    success: PropTypes.func.isRequired,
    warn: PropTypes.func.isRequired,
    error: PropTypes.func.isRequired,
    close: PropTypes.func,
});
//# sourceMappingURL=constants.js.map